import { render, staticRenderFns } from "./MassUpdatePaymentTransferComponent.vue?vue&type=template&id=6c5a07e6&"
import script from "./MassUpdatePaymentTransferComponent.vue?vue&type=script&lang=js&"
export * from "./MassUpdatePaymentTransferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports